// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"ChangePassword_closeButton__3QVR2"};